export default "__VITE_ASSET__BHFn9H7___"